(function () {
  if (window.__musicPlayerInit) return;
  window.__musicPlayerInit = true;

  function initMusicPlayer(root) {
    if (!root) return;

    const audio = root.querySelector('[data-music-audio]');
    const playBtn = root.querySelector('.playBtn');
    const pauseBtn = root.querySelector('.pauseBtn');

    if (!audio || !playBtn || !pauseBtn) return;

    let fullPause = false;
    const STORAGE_KEY = 'bg_music_state'; // 'playing' | 'paused'
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'paused') fullPause = true;

    function setUi(isPlaying) {
      playBtn.style.display = isPlaying ? 'none' : 'inline-flex';
      pauseBtn.style.display = isPlaying ? 'inline-flex' : 'none';
      root.classList.toggle('is-playing', isPlaying);
    }

    async function play() {
      fullPause = false;
      localStorage.setItem(STORAGE_KEY, 'playing');
      try {
        await audio.play();
        setUi(true);
      } catch (e) {
        setUi(false);
      }
    }

    function pause() {
      fullPause = true;
      localStorage.setItem(STORAGE_KEY, 'paused');
      audio.pause();
      setUi(false);
    }

    function tryAutoStart() {
      if (fullPause) return; // user explicitly muted
      if (!audio.paused) return;
      play();
    }

    playBtn.addEventListener('click', play);
    pauseBtn.addEventListener('click', pause);
    window.addEventListener('click', tryAutoStart, { passive: true });
    window.addEventListener('keydown', tryAutoStart);

    if (!fullPause && saved === 'playing') {
      play();
    } else {
      setUi(false);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-music-player]').forEach(initMusicPlayer);
  });
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    section.querySelectorAll && section.querySelectorAll('[data-music-player]').forEach(initMusicPlayer);
  });
})();